class AnimatedPage{

    constructor(diff = 0){
      this.diff = diff;
    }

    _killScroll(){
        if(!this._scrollHandler){return;}
        $win.off('scroll', this._scrollHandler);
    }

    /**
     * Initialisation du scroll
     */
    _initScroll(){
        const $win = $(window);
        const me = this;
        this.winHeight = $win.height();

        this._animatedElement = this._getAnimatedElements();

        this._scrollHandler = function(){
            const scrollTop = $win.scrollTop();
            me._scroll(scrollTop);

        };



        // smooth.addListener(function(status){
        //     const scrollTop = status.offset.x;
        //     me._scroll(scrollTop);
        // });
        $win.on('scroll', this._scrollHandler);
        $(window).scroll();
        this._scroll();

    }

    /**
     * scroll
     */
    _scroll(scrollTop = 0){
        const wHeight = this.winHeight;
        const diff = this._getAnimationDiff();
        const me = this;
        const $goUp = $('.Navigation .button--up');


            if(scrollTop>$(window).height()-this.diff){
                if(!$goUp.hasClass('shown')){
                    TweenLite.to($goUp,.4,{alpha:1,ease:Power4.easeOut});
                    $goUp.addClass('shown');
                }
            }else{
                 if($goUp.hasClass('shown')){
                    TweenLite.to($goUp,.4,{alpha:0,ease:Power4.easeOut});
                    $goUp.removeClass('shown');
                }
            }

        this._animatedElement.forEach(o=>{
            const $el = o.$el;
            const fn = o.fn ? o.fn : this._showElement;

            $el.each(function(){
                const $this = $(this);
                if($this.hasClass('shown')){return;}

                const offset = $this.offset().top;
                if(scrollTop + wHeight - diff > offset){
                    $this.addClass('shown');
                    fn.call(me, $this);
                }
            })
        })

    }


    _getAnimationDiff(){
        return this.diff;
    }

    /**
     * Retourne les éléments à afficher au scroll, ainsi que les timelines associés
     * @return $el, fn
     */
    _getAnimatedElements(){
        return [
            {$el:$('.AnimatedElement'), fn:this._showElement}
        ];
    }

    /**
     * Retourne une timeline par défaut pour les éléments à afficher au scroll.
     * @return timeline
     */
    _showElement($el){
        return new TimelineLite()
            .fromTo($el, .3, {autoAlpha:0}, {autoAlpha:1})
        ;
    }

    /**
     * Retourne une timeline par défaut pour le body.
     * @return timeline
     */
    showBody(){
        const tl = new TimelineLite()
            .to($('body'),.7,{autoAlpha:1, ease:Power4.easeOut})
        ;
        return tl;
    }

    /**
     * Retourne une timeline par défaut pour le header.
     * @return timeline
     */
    showHeader(){
        const tl = new TimelineLite()
            .fromTo($('.SiteHeader'),.7,{autoAlpha:0,y:50},{autoAlpha:1,y:0, ease:Power4.easeOut})
        ;
        return tl;
    }
}
export default AnimatedPage;
